type PopupType = 'all-users' | 'new-users';

const isObjectLike = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

export const normalizePopupType = (value: unknown): PopupType | undefined => {
  if (value === 'all-users' || value === 'new-users') {
    return value;
  }
  return undefined;
};

export const normalizeBroadcastPopupDraftInput = (
  value: unknown
): { text: string; popupType: PopupType } | null => {
  if (!isObjectLike(value)) return null;
  const text = typeof value.text === 'string' ? value.text : undefined;
  const popupType = normalizePopupType(value.popupType);
  if (!text || !popupType) return null;
  return { text, popupType };
};
